'use strict'

// An image column can be filled from an address. The value is the address to
// download, not the picture itself. The server stores the downloaded bytes.

function isImageUrlValue (value) {

  if (!value || typeof value !== 'object') return false
  if (typeof value.url !== 'string' || !value.url.trim()) return false
  if (typeof value.data === 'string' && value.data) return false

  return true
}

function imageUrlText (value) {

  if (typeof value === 'string') {

    const text = value.trim()

    if (!text || text[0] !== '{') return ''

    try {

      return imageUrlText(JSON.parse(text))
    } catch (err) {

      return ''
    }
  }

  return isImageUrlValue(value) ? value.url.trim() : ''
}

function filenameFromImageUrl (url, contentType) {

  let name = 'image'

  try {

    const parsed = new URL(url)
    const last = parsed.pathname.split('/').filter(Boolean).pop()

    if (last) name = decodeURIComponent(last).slice(0, 180)
  } catch (err) {

    name = 'image'
  }

  if (name.indexOf('.') >= 0) return name

  const type = String(contentType || '').toLowerCase()

  if (type.indexOf('png') >= 0) return `${name}.png`
  if (type.indexOf('jpeg') >= 0 || type.indexOf('jpg') >= 0) return `${name}.jpg`
  if (type.indexOf('gif') >= 0) return `${name}.gif`
  if (type.indexOf('webp') >= 0) return `${name}.webp`

  return name
}

function coerceImageUrlValue (value) {

  const url = imageUrlText(value)

  return url ? { url } : null
}

module.exports = {
  isImageUrlValue,
  imageUrlText,
  filenameFromImageUrl,
  coerceImageUrlValue
}
